// BUSHCRAFTER — 12 tools in 3 blocks. Marker positions are card millimetres (mx from the face's
// left edge, my from its top); est:true = authored guess, replaced the moment a mark is placed.
// hom = photo% -> card fraction, fitted per face against the STL silhouette (A 0.837 vs 0.555 on the
// wrong face, B 0.857 vs 0.566) — the same test also proves which photo shows which face.
window.BUSH = {
 "hom": {
  "A": [[0.01161, 0.000401, -0.099915], [-0.000279, 0.016006, -0.300428], [-0.000834, 0.001328, 1]],
  "B": [[0.012101, 0.000331, -0.099901], [-0.000222, 0.016122, -0.186859], [-0.000175, 0.000776, 1]]
 },
 "photo": { "A": "https://mrf.tools/cdn/shop/files/mrf26-bush-photo-a.jpg?v=b3", "B": "https://mrf.tools/cdn/shop/files/mrf26-bush-photo-b.jpg?v=b3" },
 "blocks": [
  {
   "name": "Fire & line",
   "tools": [
    { "n": 1, "cat": "FIRE", "side": "A", "mx": 36.6, "my": 9.8, "est": false, "part": "rod",
      "name": "Ferro rod",
      "desc": "A ferrocerium rod rides on the card in two O-rings — pull it out, strike it against the serrated edge and you have sparks at 3000 °C.",
      "sc": "Lighting a fire in the rain, when a lighter has already given up." },
    { "n": 2, "cat": "FIRE", "side": "A", "mx": 0, "my": 12.5, "est": false,
      "name": "Line winder",
      "desc": "The long paired slots wind fishing line, snare wire or cord and hold the end without a knot.",
      "sc": "Keeping 20 m of line tangle-free in a pocket." },
    { "n": 3, "cat": "CUT", "side": "A", "mx": 60, "my": 52, "est": true,
      "name": "Serrated blade",
      "desc": "Saw teeth along the bottom edge: green wood, bone, rope — and the striking surface for the ferro rod.",
      "sc": "Notching a stick for a pot hanger." },
    { "n": 4, "cat": "CAMP", "side": "A", "mx": 83.4, "my": 55, "est": false,
      "name": "Box opener",
      "desc": "Hooked cutter that opens tape and cardboard without a blade in your hand.",
      "sc": "Unpacking a resupply box at a trailhead." }
   ]
  },
  {
   "name": "Cut & dig",
   "tools": [
    { "n": 5, "cat": "CUT", "side": "A", "mx": 65.9, "my": 51.2, "est": false,
      "name": "Knife",
      "desc": "The long ground edge — 440C at 52–54 HRC, the blade the rest of the card is built around.",
      "sc": "Preparing tinder and dinner with the same tool." },
    { "n": 6, "cat": "CUT", "side": "A", "mx": 83.7, "my": 29.9, "est": false,
      "name": "Axe",
      "desc": "Heavy forward edge for chopping: lash the card to a shaft and it splits kindling.",
      "sc": "Making firewood from a fallen branch." },
    { "n": 7, "cat": "CUT", "side": "A", "mx": 84.1, "my": 22.9, "est": false,
      "name": "Scraper",
      "desc": "Blunt back edge for scraping bark, resin or char cloth without dulling the knife.",
      "sc": "Peeling birch bark for tinder." },
    { "n": 8, "cat": "CAMP", "side": "A", "mx": 84.3, "my": 16.4, "est": false,
      "name": "Shovel",
      "desc": "The wedge end digs — a fire pit, a peg hole, a drainage trench round a tent.",
      "sc": "Digging a fire pit in packed forest floor." }
   ]
  },
  {
   "name": "Navigate & measure",
   "tools": [
    { "n": 9, "cat": "NAVIGATE", "side": "B", "mx": 1.6, "my": 27.2, "est": false,
      "name": "Sun compass",
      "desc": "Engraved rose around the gnomon hole: set it by the sun and you have bearings without a needle.",
      "sc": "Finding north on a ridge with a dead phone." },
    { "n": 10, "cat": "NAVIGATE", "side": "B", "mx": 18.5, "my": 26.9, "est": false,
      "name": "Sundial clock",
      "desc": "Hour lines 6 to 18 with the North/South 12:00 axis — stand a twig in the hole and read the time off the shadow.",
      "sc": "Telling the hour on day three with no battery left." },
    { "n": 11, "cat": "MEASURE", "side": "B", "mx": 38.6, "my": 31, "est": false,
      "name": "Distance ruler",
      "desc": "Rangefinder ladder: match a 1.6 m figure to the marks and read 25 to 200 m straight off the edge.",
      "sc": "Judging the distance across a clearing before crossing it." },
    { "n": 12, "cat": "SYSTEM", "side": "A", "mx": 8.4, "my": 23.5, "est": false,
      "name": "KIT connector",
      "desc": "The keyed window and pin hole take MRF kit plates, so the card grows into whatever the trip needs.",
      "sc": "Adding a kit plate before a week in the woods." }
   ]
  }
 ]
};
